import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

import { determineCanadaChequingApplicability } from "./utils";

export class CanadaChequingAccountField extends Field<number> {
  constructor(model: Merchant, opts: Partial<MerchantField<number>> = {}) {
    super(model, {
      dataType: "number",
      testValue: 4884448888,
      propertyName: "canadaChequingAccount",
      uiFieldType: "Input",
      uiInputBaseProps: {
        inputMode: "numeric",
      },
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    if (determineCanadaChequingApplicability(registeredCountry)) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
